import {createSlice} from '@reduxjs/toolkit';

export const resendOrderSlice = createSlice({
    name: 'resendOrders',
    initialState: {
        dataArray: [],
        isLoading: false,
        selectedFile: '',
        rsOptions: [],
        crOptions: [],
    },
    reducers: {
        updateResendOrders: (state, action) => {
            state.dataArray = action.payload;
        },
        toggleLoadingResendOrders: (state, action) => {
            state.isLoading = !state.isLoading;
        },
        setRsOptions: (state, action) => {
            state.rsOptions = action.payload;
        },
        setCrOptions: (state, action) => {
            state.crOptions = action.payload.map((obj) => obj.resend_req_no);
        },
    },
});

export const {
    updateResendOrders,
    toggleLoadingResendOrders,
    setRsOptions,
    setCrOptions,
} = resendOrderSlice.actions;

export default resendOrderSlice.reducer;
